export const getCardType = (number: string) => {
    const regexPatterns = {
        visa: /^4/,
        mastercard: /^5[1-5]/,
        amex: /^3[47]/,
        diners: /^3(?:0[0-5]|[68])/,
        discover: /^6(?:011|5[0-9]{2})/,
        jcb: /^(?:2131|1800|35\d{3})/,
    };

    for (const card in regexPatterns) {
        if (regexPatterns[card as keyof typeof regexPatterns].test(number)) {
            return card;
        }
    }
    return "other";
};

export const formatCardNumber = (number: string, cardType: string) => {
    if (!number) return "";

    let formattedNumber = number.replace(/\D/g, ""); // Remove non-digit characters
    if (cardType === "amex") {
        formattedNumber = formattedNumber.replace(/(\d{4})(\d{6})(\d{5})/, "$1 $2 $3");
    } else {
        formattedNumber = formattedNumber.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, "$1 $2 $3 $4");
    }
    return formattedNumber.trim();
};

export const cardImages: { [key: string]: string } = {
    visa: "assets/images/icons/visa.svg",
    mastercard: "assets/images/icons/mastercard.svg",
    amex: "assets/images/icons/amex.svg",
    // Add paths for other card types
};